import script from "./ForumMiniPost.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumMiniPost.vue?vue&type=script&setup=true&lang=js"

import "./ForumMiniPost.vue?vue&type=style&index=0&id=22dae16a&lang=css"

const __exports__ = script;

export default __exports__